<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1627 8.59404C21.3968 6.35518 19.3129 4.11319 17 2C9.98143 8.41039 5 16.7628 5 21.8C5 30.7473 12.1636 38 21 38C29.8364 38 37 30.7473 37 21.8C37 18.0545 33.2871 10.3292 28.1114 5.6C27.0295 6.58826 26.024 7.61343 25.0984 8.65109C24.753 9.03829 24.4187 9.42723 24.0957 9.81664C23.7956 9.40974 23.4845 9.00194 23.1627 8.59404ZM28.098 7.67779C27.0676 8.68825 26.117 9.72924 25.2502 10.7743L24.0264 12.2498L22.8885 10.7069C21.2459 8.47965 19.2524 6.21466 17.0025 4.0568C14.0304 6.93519 11.4927 10.1389 9.65246 13.1897C7.57796 16.6289 6.5 19.6909 6.5 21.8C6.5 29.9364 13.0095 36.5 21 36.5C28.9905 36.5 35.5 29.9364 35.5 21.8C35.5 20.2956 34.7087 17.6903 33.1694 14.7679C31.8674 12.2957 30.1131 9.7554 28.098 7.67779Z"
      class="fill-current"
    />
    <path
      d="M19.2221 25.9C19.5936 26.2393 19.9289 26.5959 20.2261 26.9542C20.7129 26.2941 21.3164 25.6245 22 25C23.7546 26.6026 25 28.6907 25 29.95C25 32.1868 23.2091 34 21 34C18.7909 34 17 32.1868 17 29.95C17 29.0136 17.9282 27.0823 19.2221 25.9Z"
      class="fill-current"
    />
  </svg>
</template>
